// forEach IE11 Polyfill

if ('NodeList' in window && !NodeList.prototype.forEach) {
  console.info('polyfill for IE11');
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}


window.addEventListener('popstate', (e) => {
  if(window.historyBackFunction) window.historyBackFunction(e.state);
})



document.querySelector("header .toggle-nav")?.addEventListener("click", (e) => {
  document.querySelector(".mobile-nav").classList.add("show")
})

document.querySelector(".mobile-nav .close")?.addEventListener("click", (e) => {
  document.querySelector(".mobile-nav").classList.remove("show")
})

function autoResize(el) {
  if (el.height && el.width) {
    el.style.height = (el.offsetWidth * (el.height / el.width)) + "px"
    return true
  }
  return false
}
window.doSingleAutoResize = autoResize

function doAutoResize() {
  document.querySelectorAll(".autoResize").forEach(autoResize)
}
window.doAutoResize = doAutoResize

doAutoResize()
window.addEventListener("resize", doAutoResize)
window.addEventListener("load", doAutoResize)
window.document.addEventListener("ready", doAutoResize)
setInterval(doAutoResize, 1333)